const SET_OVERALL_ANSWER = 'SET_OVERALL_ANSWER';


/**
 * Action to update the additional feedback comment
 * associated with the Overall additional feedback question.
 */
export const setOverallAnswer = (data) => {
    return {
        type: SET_OVERALL_ANSWER,
        data
    };
};



// WEBPACK FOOTER //
// ./application/containers/OverallAdditionalFeedback/actions.js